import { KindName } from 'types/hoopla'
import create, { SetState, State } from 'zustand'

interface CurrentlyPlayingState extends State {
  currentlyPlayingTitle: Title['id'] // titleId
  currentlyPlayingTitleName: Title['title']
  currentlyPlayingKind: KindName | null
  currentEpisode: Title['episode']
  currentlyPlayingActive: boolean
  isCastable: boolean

  clearCurrentlyPlayingTitle: () => void
  setCurrentlyPlayingTitle: (
    currentlyPlayingTitleName: Title['title'],
    currentlyPlayingTitle: Title['id'],
    currentlyPlayingKind: KindName | null,
    currentEpisode?: Title['episode'],
  ) => void
}

export const useCurrentlyPlaying = create<CurrentlyPlayingState>(
  (set: SetState<CurrentlyPlayingState>) => ({
    currentlyPlayingTitleName: '',
    currentlyPlayingTitle: '',
    currentlyPlayingKind: null,
    currentEpisode: 0,
    currentlyPlayingActive: false,
    isCastable: false,

    clearCurrentlyPlayingTitle: () =>
      set({
        currentlyPlayingTitleName: '',
        currentlyPlayingTitle: '',
        currentlyPlayingKind: KindName.Audiobook,
        currentEpisode: 0,
        currentlyPlayingActive: false,
      }),
    setCurrentlyPlayingTitle: (
      currentlyPlayingTitleName,
      currentlyPlayingTitle,
      currentlyPlayingKind,
      currentEpisode = 0,
      currentlyPlayingActive = true,
      isCastable = !!currentlyPlayingKind &&
        [KindName.Movie, KindName.Television].includes(currentlyPlayingKind),
    ) =>
      set({
        currentlyPlayingTitleName,
        currentlyPlayingTitle,
        currentlyPlayingKind,
        currentEpisode,
        currentlyPlayingActive,
        isCastable,
      }),
  }),
)
